export const sweetBeanFlatbread = {
  id: "sweetBeanFlatbread",
  link: "/#/recipes/recipes/sweetBeanFlatbread",
  name: "Sweet Bean Flatbread",
  cuisine: "Alethi",
  summary: "Corn-based flatbread filled with a thin layer of sweet bean paste",
  inspiration: "Pupusas",
  quantity: "4",
  time: "30 minutes",
  notes:
    "While bean paste and pupusas come from opposite sides of the world, sweet pupusas do exist. Given the ingredients available on Roshar and the description in the book, this seemed like the obvious choice.",
  quotes:
    "Kaladin sat up and regarded his meal. Flatbread stuffed with bean paste. (Words of Radiance ch 62)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/filled-flatbread-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "maseca",
          display: "1 1/4 cups Mexican-style corn flour (Maseca)"
        },
        {
          item: "salt",
          display: "1/2 tsp salt"
        },
        {
          item: "water",
          display: "1 cup water, plus additional"
        },
        {
          item: "honey",
          display: "1 tbsp honey"
        },
        {
          item: "vegetableOil",
          display: "Vegetable oil"
        },
        {
          item: "beanPaste",
          display: "6 tbsp sweet bean paste"
        }
      ]
    }
  ],
  steps: [
    "In a large bowl, combine the maseca, salt, 1 cup of water, and the honey. Knead together until well combined. Knead in additonal water, 1 tbsp at a time, to get a soft, wet dough that you can easily pat flat.",
    "Heat an electric griddle to 375 degrees Fahrenheit. Fill a small bowl halfway with water, then pour in enough oil just to cover the surface of the water.",
    "For each flatbread, dip your hands in the oil/water. Pull off a chunk of dough, and slap it between your hands to form a thin disk that's a good amount larger than your hand.",
    "Place 1 1/2 tbsp of bean paste in the center of the dough. Wrap the dough around the paste and pinch off the extra dough to form a ball with the paste in the center. Slap the ball between your hands to flatten to about 1/4 inch thick, or a little thicker if the bean paste starts to show through in spots.",
    "Cook the flatbread on the griddle, flipping once, until both sides have some browned spots. Serve warm."
  ]
}
